import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CContainer,
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText,
    CRow,
    CSpinner,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { forgotPassword } from '../../utils/backend';
import AnsaLogo from '../../assets/images/ansa/ansa-logo.svg';
import { cilUser } from '@coreui/icons';
import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const initialValues = {
        email: '',
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('Invalid email')
            .required('Email is required'),
    });

    const handleNext = async (values, { setSubmitting, setErrors, setFieldTouched }) => {
        setLoading(true);
        try {
            const response = await forgotPassword({ email: values.email });
            if (response.success) {
                toast.success(response.message);
                navigate('/forgot-password/reset-password');
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error('RequestFailed', error);
            toast.error(error.message);
            setErrors({ submit: 'Request failed', ...error.fieldErrors });
            Object.keys(values).forEach(field => setFieldTouched(field, true, false));
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-left">
                <img src={AnsaLogo} alt="Ansa Logo" />
            </div>
            <div className="login-right">
                <CContainer>
                    <CRow className="justify-content-center">
                        <CCol md={8}>
                            <CCard className="p-4 border-light">
                                <CCardBody>
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={handleNext}
                                    >
                                        {({ isSubmitting, errors, touched }) => (
                                            <Form>
                                                <h2>Forgot Password</h2>
                                                <p className="text-body-secondary">Enter your email to reset your password</p>
                                                {loading ? (
                                                    <div className="text-center">
                                                        <CSpinner color="primary" />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {errors.submit && (
                                                            <div className="alert alert-danger">{errors.submit}</div>
                                                        )}
                                                        <CInputGroup className="mb-3">
                                                            <CInputGroupText>
                                                                <CIcon icon={cilUser} />
                                                            </CInputGroupText>
                                                            <Field
                                                                name="email"
                                                                as={CFormInput}
                                                                placeholder="Email"
                                                                autoComplete="email"
                                                                className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                                                            />
                                                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                                                        </CInputGroup>
                                                        <CRow>
                                                            <CCol>
                                                                <div className="d-flex justify-content-start">
                                                                    <button type="button" className="btn me-3 ansa-button-secondary" onClick={() => navigate('/login')}>Back</button>
                                                                    <CButton type="submit" className="ansa-button-primary" disabled={isSubmitting}>
                                                                        Next
                                                                    </CButton>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </>
                                                )}
                                            </Form>
                                        )}
                                    </Formik>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </CContainer>
            </div>
        </div>
    );
};

export default ForgotPassword;